import React, { useCallback, useMemo } from 'react';

import {
	SummaryItemComp,
	SummaryItemDropComp,
	Button,
	Hide,
} from '@components';

import { Agenda, SummaryBlock, SummaryBlockItem } from '@api';

import './summary-block.scss';
import { DragHandleIcon } from '@icons';

interface SummaryBlockCompProps {
	summaryBlock: SummaryBlock,
	agenda: Agenda,
	onSummaryItemAdd: (summaryItemIndex: number, agendaItemId: string) => void,
	onSummaryItemDelete: (summaryItemIndex: number, agendaItemId: string) => void,
	onSummaryItemEdit: (summaryItemIndex: number, agendaItemId: string) => void,
	onSummaryItemDrop: (summaryItem: SummaryBlockItem, summaryItemIndex: number, agendaItemId: string) => void,
	onSummaryItemReorderDrop: (oldBlock: SummaryBlock, oldIdex: number, newIndex: number, oldAgendaItemId: string, newAgendaItemId: string) => void,
	onHighlightihgChanged: (ids: string[]) => void,
	canEdit: boolean,
}

function SummaryBlockComp(props: SummaryBlockCompProps): JSX.Element {
	const {
		onSummaryItemDelete,
		onSummaryItemEdit,
		onSummaryItemAdd,
		onSummaryItemDrop,
		onSummaryItemReorderDrop,
		onHighlightihgChanged,
		summaryBlock,
		canEdit,
		agenda,
	} = props;

	const addNewSummaryItem = useCallback(() => {
		onSummaryItemAdd(summaryBlock.items.length, null);
	}, [onSummaryItemAdd, summaryBlock]);

	const addNewSummaryItemAfterCurrent = useCallback((indexToAddSummaryItem: number, agendaItemId: string) => {
		onSummaryItemAdd(indexToAddSummaryItem, agendaItemId);
	}, [onSummaryItemAdd]);

	const blocksView = useMemo(() => {

		const renderItems= (sourceItems: SummaryBlockItem[], agendaItemId: string) => {
			let items = sourceItems.map((summaryItem, i) => (
				<React.Fragment key={i}>
					<SummaryItemComp
						onSummaryItemAdd={addNewSummaryItemAfterCurrent}
						onSummaryItemDelete={onSummaryItemDelete}
						onSummaryItemEdit={onSummaryItemEdit}
						summaryItem={summaryItem}
						summaryItemIndex={i}
						summaryBlock={summaryBlock}
						canEdit={canEdit}
						onHighlightihgChanged={onHighlightihgChanged}
					/>
					<SummaryItemDropComp
						newIndex={i + 1}
						agendaItemId={agendaItemId}
						onSummaryItemDrop={onSummaryItemDrop}
						onSummaryItemReorderDrop={onSummaryItemReorderDrop}
						summaryBlock={summaryBlock}
						canEdit={canEdit}
					/>
				</React.Fragment>
			));
	
			const firstItem = <SummaryItemDropComp
				key={-999999}
				newIndex={0}
				agendaItemId={agendaItemId}
				onSummaryItemDrop={onSummaryItemDrop}
				onSummaryItemReorderDrop={onSummaryItemReorderDrop}
				summaryBlock={summaryBlock}
				canEdit={canEdit}
			/>;
	
			items = [firstItem].concat(items);
	
			return items;
		};


		const agendaItemsView = agenda && agenda.showInSummary && summaryBlock.showAgenda && agenda && agenda.items
			? agenda.items.map((agendaItem, ix) => {
				const children = summaryBlock.__data.agendaItems[agendaItem.id];
				const childrenView = renderItems(children || [], agendaItem.id);

				return <div className='summary-agenda-wrapper' key={agendaItem.id}>
					<div className='summary-agenda-item' title={agendaItem.text} draggable={false}>
						<DragHandleIcon className='item-handle' />
						<span className='item-num'>{ix+1}. </span>
						<div className='item-text'>{agendaItem.text}</div>
					</div>
					{/* {agendaItem.id} */}
					{childrenView}
				</div>
			}) 
			: null;

		const orphans = summaryBlock.__data.items;
		const orphansView = renderItems(orphans, null);

		return (<>
			{agendaItemsView}
			{orphansView}
		</>);
	}, [summaryBlock, agenda, addNewSummaryItemAfterCurrent, canEdit, onSummaryItemDelete, onSummaryItemDrop,
		onSummaryItemEdit, onSummaryItemReorderDrop, onHighlightihgChanged]);

	return summaryBlock && (
		<div className="summary-block">
			<Hide
				label={summaryBlock.blockName}
				defaultExpanded={true}
				size='big'
				className='summary-block__title'
			>
				<div className="summary-block__content">
					{blocksView}
				</div>
				{canEdit && <Button onClick={addNewSummaryItem} theme="ghost">
					+ Добавить итог
				</Button>}
			</Hide>
		</div>
	);
}

const MemoisedSummaryBlockComp = React.memo(SummaryBlockComp);

export {MemoisedSummaryBlockComp as SummaryBlockComp};